<template>
  <FullScreen>
    <div class="flex flex-col items-center m-auto" style="width: 30%;">
      <payment-success-icon></payment-success-icon>
      <div class="mt-10 mb-5 text-center">
        <h1>Pembayaran Berhasil</h1>
        <div class="mt-5">
          <p style="line-height: 22px!important;">Alhamdulillah pembayaran anda telah berhasil kami terima,
Sekarang anda dapat mulai belajar sekarang juga</p>
        </div>
      </div>
      <div class="mb-5">
        <va-button type="primary" @click.prevent="goBack()">Mulai Belajar</va-button>
      </div>
      <a class="th-hover-underline" href="#" @click.prevent="goback">Kembali</a>
    </div>
  </FullScreen>
</template>

<script>
const FullScreen = () => import('@/components/App/FullScreen')
const PaymentSuccessIcon = () => import('@/components/Icon/PaymentSuccess')

export default {
  data() {
    return {
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Course Saya' })
    },
  },
  components: { FullScreen, PaymentSuccessIcon },
  created() {
  },
}
</script>

<style>

</style>
